// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".range-label[data-v-106d9812]{width:100px}@media(max-width:767px){.range-label[data-v-106d9812]{width:80px}}.period-picker[data-v-106d9812]{max-width:270px}@media(max-width:1279px){.period-picker-front[data-v-106d9812]{margin-top:70px;position:relative;z-index:10}}@media(min-width:768px)and (max-width:1279px){.period-picker-front[data-v-106d9812]{margin-bottom:20px}}.cost-breakdown-content__period-picker[data-v-106d9812]{max-width:220px!important}", ""]);
// Exports
module.exports = exports;
